import { SidebarStatusProvider } from "@rageeb/frontend-lib";
import { AppRoutes } from "./routes";

export const AppRouter = () => {
	return (
		<SidebarStatusProvider>
			<AppRoutes />
		</SidebarStatusProvider>
	);
};

export { isPublicRoute, PUBLIC_ROUTES } from "./routes";
